import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SsomaRoutingModule } from './ssoma-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ArtComponent } from './art/art.component';
import { InvestigacionIncidentesComponent } from './investigacion-incidentes/investigacion-incidentes.component';

import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbStepperModule } from 'mdb-angular-ui-kit/stepper';

import { MdbSelectModule } from 'mdb-angular-ui-kit/select';

import { ReactiveFormsModule } from '@angular/forms';
import { MdbLoadingModule } from 'mdb-angular-ui-kit/loading';

import { HttpClientModule } from '@angular/common/http';
 
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';

import { MdbTimepickerModule } from 'mdb-angular-ui-kit/timepicker';

import { MdbFileUploadModule } from 'mdb-angular-file-upload';


@NgModule({
  declarations: [
    DashboardComponent,
    ArtComponent,
    InvestigacionIncidentesComponent
  ],
  imports: [
    MdbFormsModule,
    MdbStepperModule,
    CommonModule,
    SsomaRoutingModule,
    ReactiveFormsModule,
    MdbSelectModule,
    MdbLoadingModule,
    HttpClientModule,
    MdbDatepickerModule,
    MdbTimepickerModule,
    MdbFileUploadModule
  ]
})
export class SsomaModule { }
